import { handleActions } from "redux-actions";

import { storeTenantsAction, isLoadingTenantsAction } from "./actions";

const initialState = {
    isLoading: false,
    tenants: {},
    ids: []
};

export const tenantsReducer = handleActions(
    {
        [storeTenantsAction]: (state, { payload }) => ({
            ...state,
            ...payload
        }),
        [isLoadingTenantsAction]: (state, { payload }) => ({
            ...state,
            isLoading: payload
        })
    },
    initialState
);